var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirdedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0140CD",
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-1.26-9.374l-2.966-3.072c-.575-.596-1.525-.613-2.12-.037-.597.575-.613 1.525-.038 2.12l4.168 4.317c.027.027.054.053.083.079.072.076.155.145.245.207.687.463 1.62.282 2.083-.405l6.71-9.949c.463-.686.282-1.619-.405-2.082-.686-.463-1.619-.282-2.082.405l-5.677 8.417z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirdedCheck);
export default __webpack_public_path__ + "static/media/girded-check.5e026cd077a432dde20d66e92d8e828c.svg";
export { ForwardRef as ReactComponent };